import { h } from 'preact';

import { MembershipTier } from '../../../membership/components/membership-tier/membership-tier.component';
import type { Membership, Tier } from '../../../membership/models/membership.model';
type Product = any;

type Props = {
  memberships: Membership[];
  products: Product[];
};

export function MembershipsView({ memberships = [], products = [] }: Props) {
  return (
    <>
      {memberships.map((membership: Membership, i: number) => (
        <div key={`m-${i}`}>
          {membership.tiers?.map((tier: Tier, j: number) => (
            <div key={`t-${i}-${j}`}>
              <MembershipTier
                membership={membership}
                accountSettings={membership.accountSettings}
                tier={tier}
                layout="row"
                showProgramName={true}
                showTierName={true}
                showTierImage={true}
                showTierDescription={false}
                showQuickAdd={true}
                showPrice={true}
                titleFormat="small"
              />
              <hr className="single-hr" />
            </div>
          ))}
        </div>
      ))}
    </>
  );
}
